<!--
 * @Description: 综合素质评价 添加
 * @Author: PF
 * @Date: 2024-05-20 17:41:06
 * @LastEditors: PF
 * @LastEditTime: 2025-07-17 15:21:48
-->
<template>
  <div>
    <el-dialog class="wp80 hp80" :model-value="openAdd" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">学生综合素质评价表</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAdd', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <div class="mt10">
              <span><span style="font-weight: bold;">班级</span>：{{row.bjmc}}</span>
              <span class="ml10"><span style="font-weight: bold;">姓名：</span>{{row.xsxm}}</span>
              <span class="ml10"><span style="font-weight: bold;">学期：</span>{{row.xqmc}}</span>
            </div>
          </el-header>
          <el-main>
            <el-table :data="tableData" v-loading="loading" border height="100%" :span-method="spanMethod">
              <el-table-column label="评价维度" prop="pjwd" width="150" align="center" />
              <el-table-column label="评价要素" prop="pjys" min-width="200" header-align="center" align="left" />
              <el-table-column label="评价内容" prop="pjnr" min-width="200" header-align="center" align="left" />
              <el-table-column label="评价标准" prop="pjbz" min-width="200" header-align="center" align="left" />
              <el-table-column label="得分" prop="fs" min-width="120" align="center">
                <template #default="scope">
                  <el-input-number v-model="scope.row.fs" :min="0" :precision="1" :max="scope.row.fz" />
                </template>
              </el-table-column>
            </el-table>
          </el-main>
        </el-container>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openAdd', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, computed } from 'vue'
import { actionPost, closeWindow } from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo.js'
import { getRowspanMethod } from '@/utils/index.js'

const props = defineProps({
  openAdd: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openAdd'])

const loading = ref(false)

const tableData = ref([])

const spanMethod = computed(() =>
  getRowspanMethod(tableData.value, ['pjwd'])
)

const row = ref()
watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      row.value = props.row
      loading.value = true
      actionPost({ url: '/api/v2/xuesheng/deyupingjiamuban/list', data: {} }).then((res) => {
        if (res.code === 200) {
          tableData.value = res.data.map(item => {
            item.fs = 0
            return item
          })
          loading.value = false
        } else {
          warningPrompt(res.message)
        }
      })
    }
  },
  { deep: true, immediate: true }
)
// 提交
const submit = async () => {
  const list = tableData.value.map(item => { item.pjmbid = item.id; return item })
  actionPost({ url: '/api/v2/xuesheng/deyupingjiapingjia', data: { dypjlbid: row.value.id, listpjxq: list } }).then((res) => {
    if (res.code === 200) {
      closeWindow('openAdd', emits, true)
    } else {
      warningPrompt(res.message)
    }
  })
}
</script>

<style lang="less" scoped>
:deep(tr:hover > td) {
  background-color: #fff !important;
}
</style>
